const fileFormat = [
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	"text/csv",
];
export default fileFormat;
